export enum ButtonAction {
    Approve = 1,
    Edit = 2,
    Delete = 3,
    SentToTenant = 4
  }